import { render, staticRenderFns } from "./ContactForResolvingMergeFields.vue?vue&type=template&id=fc5484c6&scoped=true"
import script from "./ContactForResolvingMergeFields.vue?vue&type=script&lang=js"
export * from "./ContactForResolvingMergeFields.vue?vue&type=script&lang=js"
import style0 from "./ContactForResolvingMergeFields.vue?vue&type=style&index=0&id=fc5484c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5484c6",
  null
  
)

export default component.exports